module.exports = __webpack_public_path__ + "img/partner2.b9d6bf88.png";